import { render } from "./MyCompanyCategory.vue?vue&type=template&id=3092f497"
import script from "./MyCompanyCategory.vue?vue&type=script&lang=js"
export * from "./MyCompanyCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__